import { PatchData } from "../Data/PatchData";

export class GalleryQuiltData {
    public readonly index: number;
    public readonly patches: PatchData[];
    public readonly positions: PIXI.Point[];

    constructor(pIndex: number, pPatches: PatchData[], pPositions: PIXI.Point[]) {
        this.index = pIndex;
        this.patches = pPatches;
        this.positions = pPositions;
    }
}
